<template>
<div class="quiz-question text-left">
  <div class="question-title text-center">
    <h3>{{ question.title }}</h3>
    <p class="text-italic" v-show="question.kind === 'single'">
      {{ $t('select_best_answer') }}
    </p>
    <p class="text-italic" v-show="question.kind === 'true-false'">
      {{ $t('true_false_answer') }}
    </p>
    <p class="text-italic" v-show="question.kind === 'multiple'">
      {{ $t('select_all_answers') }}
    </p>
    <p class="text-italic" v-show="question.kind === 'multiple-two'">
      {{ $t('select_two_answers') }}
    </p>
    <p class="text-italic" v-show="question.kind === 'multiple-three'">
      {{ $t('select_best_three_answers') }}
    </p>
    <p class="text-italic" v-show="question.kind === 'multiple-four'">
      {{ $t('select_best_four_answers') }}
    </p>
    <p class="text-italic" v-show="question.kind === 'text'">
      {{ $t('type_in_the_answer') }}
    </p>
  </div>

  <div class="code code-block" v-show="question.code_block">
    <code v-html="code_block_text">
    </code>
  </div>
<text-question
      :question.sync="question"
      :resolve="resolve"
      :sendAnswer="answer"
      v-if="question.kind === 'text'">
  </text-question>
  <multiple-question
      :question.sync="question"
      :resolve="resolve"
      :sendAnswer="answer"
      :max-choice="getChoice(question.kind)"
      v-else
      >
  </multiple-question>

  <a href="https://www.udemy.com/course/agile-scrum-for-beginners-scrum-master-certification-preparation/?couponCode=SCRUMQUIZ_2023" target="_blank"><b>Difficult question? Take a Scrum course.</b></a>  |
  <a href="https://us02web.zoom.us/meeting/register/tZcofuGurz8sGNBMaXw3WpCLAUV1CP-yGPZM" target="_blank">Join the upcomming free Scrum webinar</a> |
  <a href="https://forms.gle/9SizSHuuyVeRqNyPA" target="_blank">Report an issue</a>

</div>
</template>

<script>
import MultipleQuestion from './questions/MultipleQuestion';
import TextQuestion from './questions/TextQuestion';

export default {
  name: 'Question',
  components: {
    TextQuestion,
    MultipleQuestion,
  },
  props: ['question', 'resolve'],
  computed: {
    code_block_text() {
      // Hacky new line to br stuff, TODO improve parsing
      if (!this.question || !this.question.code_block) {
        return '';
      }

      // eslint-disable-next-line
      return this.question.code_block.replace(new RegExp('\r?\n', 'g'), '<br />');
    },
  },
  methods: {
    answer(val) {
      this.$emit('answer', val);
    },
    getChoice(kind) {
      if (kind === 'true-false' || kind === 'single') {
        return 1;
      }
      return 0;
    },
  },
};
</script>

<style scoped>
  .code-block {
    margin-bottom: 15px;
  }

  .question-title {
    margin: 20px auto;
    width: 80%;
  }
</style>
